import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector} from "react-redux";
import LoadingSpinner from '../../../components/loading-spinner';
import SelectInput from "../../../components/select";
import Button from "../../../components/button";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
    searchUserTeamsActivity,
    searchFilesActivities,
} from "../../../redux/activities";
// import {URLAPI} from "../../../config";
import Footer from "../../../components/footer";

const FilesConsultations = (props) => {

    var date = new Date();

    const {token, user} = useSelector((state) => state.users_module.login.data) || null;

    const [isLoading, setIsLoading] = useState(false);
    // const [workActivities, setWorkActivities] = useState([]);
    const [activities, setActivities] = useState([]);
    const [id_usuario, setIdUsuario] = useState(0);
    const [users, setUsers] = useState([]);
    const [dateStart, setDateStart] = useState(new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA'));
    const [dateEnd, setDateEnd] = useState(new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('en-CA'));

    useEffect(() => {
        getUserTeamsActivity(token);
        // eslint-disable-next-line
    }, [token, user]);

    async function getUserTeamsActivity(token) {
        setIsLoading(true);
        let params = '';
        try {
            const response = await searchUserTeamsActivity(token, params);
            if (response && response.data && response.data.datos) {
                setUsers(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getFilesActivities(token) {
        setIsLoading(true);
        if (id_usuario === 0) {
            toast.error("Debe seleccionar un usuario", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateStart === "") {
            toast.error("Debe ingresar la fecha de inicio", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateEnd === "") {
            toast.error("Debe ingresar la fecha final", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        let params = '?id_usuario=' + id_usuario + '&&fecha_inicio=' + dateStart + '&&fecha_fin=' + dateEnd;
        try {
            const response = await searchFilesActivities(token, params);
            if (response && response.data && response.data.datos) {
                setActivities(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Actividades"
                            items={[{label: "Consulta de archivos", link: "/consulta-archivos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                            <div className="row mt-1">
                                    <div className="border_card mb-1 col-12">
                                        <p className="ml-1" style={{marginTop: 10, fontSize: 18, color: '#727E8C'}}>Búsqueda de archivos por tarea</p>
                                    </div>
                                    <div className="border_card col-12">
                                        <div className="row">
                                            <div className="col-md-4 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Usuario</label>
                                                    <SelectInput
                                                        label="Usuario"
                                                        name="id_usuario"
                                                        value={id_usuario}
                                                        onChange={(e) => setIdUsuario(parseInt(e.target.value))}
                                                        options={users ? users.map((item) => ({
                                                            name: item.nombres,
                                                            id: item.id,
                                                        })) : []}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-6 col-12">
                                                <Input
                                                    name="dateStart"
                                                    label="Desde"
                                                    type="date"
                                                    value={dateStart}
                                                    onChange={(e) => {setDateStart(e.target.value)}}
                                                />
                                            </div>
                                            <div className=" col-md-4 col-sm-6 col-12">
                                                <Input
                                                    name="dateEnd"
                                                    label="Hasta"
                                                    type="date"
                                                    value={dateEnd}
                                                    onChange={(e) => {setDateEnd(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-12 text-center">
                                                <Button type="button" text="Buscar" theme="calendar" onClick={() => {
                                                    getFilesActivities(token);
                                                }}/>
                                            </div>
                                        </div>
                                    </div>
                                    {(activities.length > 0) &&
                                        <div className="mt-1 col-12">
                                            <p className="ml-1 mb-1">Archivos encontrados</p>
                                            <table className="table able-bordered">
                                                {activities.map((a) => (
                                                    <tr>
                                                        <td>
                                                            <label>Tienda</label><br/>
                                                            <strong>{a.tienda}</strong>
                                                        </td>
                                                        <td>
                                                            <label>Fecha</label><br/>
                                                            <strong>{a.fecha_agendada}</strong>
                                                        </td>
                                                        <td>
                                                            <label>Archivo</label><br/>
                                                            <strong>{a.nombre}</strong>
                                                        </td>
                                                        <td>
                                                            {/*eslint-disable-next-line*/}
                                                            <a href={a.archivo} target="_blank">Descargar</a>
                                                        </td>
                                                        
                                                    </tr>
                                                ))}
                                            </table>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default FilesConsultations;
